import Http from "@/api/http";

export default {
  // 统计项目总人数,在职，离职，待同步，已同步人数
  findTotalPersonnel: params => {
    return Http.GET("/workerinfo/findTotalPersonnel", params);
  },
  // 文件上传
  fileUpload: params => {
    return Http.Upload("/upload/uploadFiles", params);
  },
  // 参建单位下拉框
  findCompanyAllSel: data => {
    return Http.GET("/participatingCompany/findAllSel", data);
  },
  // 班组下拉框
  findTeamManageAllSel: data => {
    return Http.GET("/teamManage/findAllSel", data);
  },
};
